/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Svc_NoteInputs */

const en_svc_note = /** @type {(inputs: Svc_NoteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`> ${i?.count} modules cataloged. Most production deployments combine two or three of these.`)
};

const ar_svc_note = /** @type {(inputs: Svc_NoteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`> تم تسجيل ${i?.count} وحدات. معظم عمليات النشر الإنتاجية تجمع بين وحدتين أو ثلاث.`)
};

const bn_svc_note = /** @type {(inputs: Svc_NoteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count}টি মডিউল আছে। বেশিরভাগ প্রোডাকশন ডিপ্লয়মেন্টে এর মধ্যে দুই-তিনটি একসঙ্গে ব্যবহার হয়।`)
};

const de_svc_note = /** @type {(inputs: Svc_NoteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`> ${i?.count} Module katalogisiert. Die meisten Produktionsbereitstellungen kombinieren zwei oder drei davon.`)
};

const es_svc_note = /** @type {(inputs: Svc_NoteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`> ${i?.count} módulos catalogados. La mayoría de las implementaciones de producción combinan dos o tres de estos.`)
};

const fr_svc_note = /** @type {(inputs: Svc_NoteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`> ${i?.count} modules catalogués. La plupart des déploiements de production en combinent deux ou trois.`)
};

const pt_svc_note = /** @type {(inputs: Svc_NoteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`> ${i?.count} módulos catalogados. A maioria das implantações de produção combina dois ou três deles.`)
};

const zh_svc_note = /** @type {(inputs: Svc_NoteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`> ${i?.count} 个模块已收录。大多数生产部署会组合其中两三个。`)
};

const tr_svc_note = /** @type {(inputs: Svc_NoteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`> ${i?.count} modül kataloglandı. Çoğu üretim yayını bunlardan iki ya da üçünü birleştirir.`)
};

const ru_svc_note = /** @type {(inputs: Svc_NoteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`> ${i?.count} модулей в каталоге. Большинство прод-деплоев сочетают два-три из них.`)
};

const pl_svc_note = /** @type {(inputs: Svc_NoteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`> ${i?.count} skatalogowanych modułów. Większość wdrożeń produkcyjnych łączy dwa lub trzy z nich.`)
};

/**
* | output |
* | --- |
* | "> {count} modules cataloged. Most production deployments combine two or three of these." |
*
* @param {Svc_NoteInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svc_note = /** @type {((inputs: Svc_NoteInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_NoteInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_note(inputs)
	if (locale === "bn") return bn_svc_note(inputs)
	if (locale === "de") return de_svc_note(inputs)
	if (locale === "es") return es_svc_note(inputs)
	if (locale === "fr") return fr_svc_note(inputs)
	if (locale === "pt") return pt_svc_note(inputs)
	if (locale === "zh") return zh_svc_note(inputs)
	if (locale === "tr") return tr_svc_note(inputs)
	if (locale === "ru") return ru_svc_note(inputs)
	if (locale === "pl") return pl_svc_note(inputs)
	return en_svc_note(inputs)
});